import React from "react";
import { Button, Paper, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

export default function CustomerEmptyState({ onAdd }) {
    return (
        <Paper variant="outlined" sx={{ p: { xs: 3, md: 6 }, textAlign: "center", borderRadius: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
                Keine Kunden gefunden
            </Typography>
            <Typography sx={{ mt: 1.5, opacity: 0.8 }}>
                Lege deinen ersten Kunden an und füge Adressen sowie Bankverbindungen hinzu.
            </Typography>
            <Button
                variant="contained"
                startIcon={<AddRoundedIcon />}
                onClick={onAdd}
                sx={{
                    mt: 3,
                    backgroundColor: "orange",
                    color: "#000",
                    fontWeight: 700,
                    "&:hover": { backgroundColor: "#ff9e1a" },
                }}
            >
                Kunde hinzufügen
            </Button>
        </Paper>
    );
}
